<template>
	<ErrorModal />
	<Toast />
	<ConfirmDialog></ConfirmDialog>

    <div class="card-container pageheader enterpriseusers">
        <div class="top">
            <div class="head">
                <h2 class="header">EnterpriseAdmin Users</h2>
            </div>
			<div class="search toprow">
                <span class="p-input-icon-left field-container">
                    <i class="pi pi-search" />
                    <InputText id="search" name="search" v-model="filters['global'].value" placeholder="Search" @focus="handleFocusSearch" @input="handleInputSearch"/>
                    <Button type="button" icon="pi pi-times" class="p-button-text clear" @click="clearFilter" />
                </span>
            </div>
        </div>
        <div class="bottom">
            <div class="search bottomrow">
                <span class="p-input-icon-left field-container">
                    <i class="pi pi-search" />
                    <InputText id="search" name="search" v-model="filters['global'].value" placeholder="Search" @focus="handleFocusSearch" @input="handleInputSearch"/>
                    <Button type="button" icon="pi pi-times" class="p-button-text clear" @click="clearFilter" />
                </span>
            </div>
            <div class="create">
                <Button label="Create User" class="p-button-rounded btn-create btn-primary" @click="openCreateDialog" />
            </div>
        </div>
    </div>
    <div class="container flex-grow-1 maintable enterpriseusers">

		<DataTable class="managerclient-data-table" ref="dt" :loading="loadingDT" :value="users" dataKey="id" :paginator="true" :rows="10"
			:filters="filters" stripedRows responsiveLayout="stack" breakpoint="800px"
			paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
			:rowsPerPageOptions="[5, 10, 25]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users">
			<Column field="name" class="name" header="Name" :sortable="true"></Column>
			<Column field="email" class="email" header="Email" :sortable="true"></Column>
			<Column field="enterprisename" class="name" header="Enterprise" :sortable="true"></Column>
			<Column field="blocked" class="status" header="Blocked?" :sortable="true">
				<template #body="slotProps">
					<Button label="Yes" class="p-button-rounded p-button-danger blocked" :class="slotProps.data.blocked"
						@click="blockunblockUser(slotProps.data)" v-if="slotProps.data.blocked == 'true'" />
					<Button label="No" class="p-button-rounded p-button-success blocked" :class="slotProps.data.blocked"
						@click="blockunblockUser(slotProps.data)" v-else />
				</template>
			</Column>
			<Column field="view" class="view" header=" " :sortable="false">
				<template #body="slotProps">
					<div class="button-container">
						<Button label="View" class="p-button-rounded btn-view btn-secondary" @click="viewUser(slotProps.data)" />
						<Button label="Edit" class="p-button-rounded btn-edit btn-secondary" @click="editUser(slotProps.data)" />
						<Button label="Change Password" class="p-button-rounded btn-password btn-primary" @click="changeUserPassword(slotProps.data)" />
					</div>
				</template>
			</Column>
			<template #empty>
				<div style="text-align: center">No users found.</div>
			</template>
		</DataTable>
        <Dialog v-model:visible="createUserDialog" header="Create EnterpriseUser Admin" :modal="true" class="p-fluid" @hide="cancelSaveUser()">
			<div class="field">
				<label for="enterprise">Enterprise<span class="req">*</span></label>
				<Dropdown v-model="user.enterpriseid" filter :options="enterprises" optionLabel="EnterpriseName" optionValue="EnterpriseId"
					placeholder="Select an enterprise" required="true" @change="getEnterpriseStores"/>
				<span class="error" v-if="vv$.enterpriseid.$error">{{ vv$.enterpriseid.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="enterprise">Enterprise Store<span class="req">*</span></label>
				<Dropdown :disabled="entstoreloading" v-model="user.storeid" filter :options="enterprisestores" optionLabel="StoreName" optionValue="StoreId"
					placeholder="Select an enterprise store" required="true"/>
				<span class="error" v-if="vv$.storeid.$error">{{ vv$.storeid.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="name">Name<span class="req">*</span></label>
				<InputText id="name" v-model.trim="user.name" required="true" />
				<span class="error" v-if="vv$.name.$error">{{ vv$.name.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="email">Email<span class="req">*</span></label>
				<InputText id="email" v-model.trim="user.email" required="true" @focus="handleFocus('email')" @input="handleInputChange('email')"/>
				<span class="error" v-if="vv$.email.$error">{{ vv$.email.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="password">Password<span class="req">*</span></label>
				<InputText type="password" id="password" v-model.trim="password" required @focus="handleFocus('password')" @input="handleInputChange('password')"/>
				<span class="error" v-if="v$.password.$error">{{ v$.password.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="confirmpassword">Confirm password<span class="req">*</span></label>
				<Password id="confirmpassword" v-model.trim="confirmpassword" required />
				<span class="error" v-if="v$.confirmpassword.$error">{{ v$.confirmpassword.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label>Blocked<span class="req">*</span></label>
				<div class="formgrid grid">
					<div class="field-radiobutton col-12">
						<InputSwitch v-model="user.blockedbool" style="border-radius: 1.5em;"/>
						<label for="status">{{ user.blockedbool ? 'Yes' : 'No' }}</label>
					</div>
				</div>
			</div>
			<template #footer>
				<Button label="Cancel" class="p-button-rounded btn-cancel btn-secondary" @click="createUserDialog = false" />
				<Button label="Save" class="p-button-rounded btn-save btn-primary" @click="saveUser" />
			</template>
		</Dialog>
		<Dialog v-model:visible="editUserDialog" header="Update EnterpriseUser Admin" :modal="true" class="p-fluid" @hide="cancelSaveUser()">
			<div class="field">
				<label for="enterprise">Enterprise<span class="req">*</span></label>
				<Dropdown v-model="user.enterpriseid" filter :options="enterprises" optionLabel="EnterpriseName" optionValue="EnterpriseId"
					placeholder="Select an enterprise" required="true" @change="getEnterpriseStores"/>
				<span class="error" v-if="vv$.enterpriseid.$error">{{ vv$.enterpriseid.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="enterprise">Enterprise Store<span class="req">*</span></label>
				<Dropdown :disabled="entstoreloading" v-model="user.storeid" filter :options="enterprisestores" optionLabel="StoreName" optionValue="StoreId"
					placeholder="Select an enterprise store" required="true"/>
				<span class="error" v-if="vv$.storeid.$error">{{ vv$.storeid.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="name">Name<span class="req">*</span></label>
				<InputText id="name" v-model.trim="user.name" required="true" />
				<span class="error" v-if="vv$.name.$error">{{ vv$.name.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="email">Email<span class="req">*</span></label>
				<InputText id="email" v-model.trim="user.email" required="true" />
				<span class="error" v-if="vv$.email.$error">{{ vv$.email.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label>Blocked<span class="req">*</span></label>
				<div class="formgrid grid">
					<div class="field-radiobutton col-12">
						<InputSwitch v-model="user.blockedbool" style="border-radius: 1.5em;"/>
						<label for="status">{{ user.blockedbool ? 'Yes' : 'No' }}</label>
					</div>
				</div>
			</div>
			<template #footer>
				<Button label="Cancel" class="p-button-rounded btn-cancel btn-secondary" @click="hideEditDialog" />
				<Button label="Delete" class="p-button-rounded btn-save btn-danger" @click="deleteUser" />
				<Button label="Save" class="p-button-rounded btn-save btn-primary" @click="updateUser" />
			</template>
		</Dialog>
		<Dialog v-model:visible="viewUserDialog" header="View EnterpriseAdmin User Details" :modal="true" class="p-fluid" @hide="cancelSaveUser()">
			<div class="data">
				<p><strong>Enterprise:</strong><br /><span>{{ user.enterprisename }}</span></p>
			</div>
			<div class="data">
				<p><strong>Enterprise ID:</strong><br /><span>{{ user.enterpriseid }}</span></p>
			</div>
			<div class="data">
				<p><strong>Enterprise Store Name:</strong><br /><span>{{ user.storename }}</span></p>
			</div>
			<div class="data">
				<p><strong>Enterprise Store ID:</strong><br /><span>{{ user.storeid }}</span></p>
			</div>
			<div class="data">
				<p><strong>Name:</strong><br /><span>{{ user.name }}</span></p>
			</div>
			<div class="data">
				<p><strong>Email:</strong><br /><span>{{ user.email }}</span></p>
			</div>
			<div class="data">
				<p><strong>Role:</strong><br /><span>{{ user.role }}</span></p>
			</div>
			<div class="data">
				<p><strong>Blocked?:</strong><br />
					<span v-if="user.blocked == 'true'" class="p-button-rounded btn-blocked">Yes</span>
					<span v-else label="No" class="p-button-rounded btn-blocked">No</span>
				</p>
			</div>
			<template #footer>
				<Button label="Cancel" class="p-button-rounded btn-cancel btn-secondary" @click="viewUserDialog = false" />
			</template>
		</Dialog>
		<Dialog v-model:visible="changePasswordDialog" header="Change password" :modal="true" class="p-fluid">
			<div class="field">
				<label for="password">New password<span class="req">*</span></label>
				<Password id="password" v-model.trim="password" required @focus="handleFocus('password')" @input="handleInputChange('password')"/>
				<span class="error" v-if="v$.password.$error">{{ v$.password.$errors[0].$message }}</span>
			</div>
			<div class="field">
				<label for="confirmpassword">Confirm password<span class="req">*</span></label>
				<Password id="confirmpassword" v-model.trim="confirmpassword" required />
				<span class="error" v-if="v$.confirmpassword.$error">{{ v$.confirmpassword.$errors[0].$message }}</span>
			</div>
			<template #footer>
				<Button label="Cancel" class="p-button-rounded btn-cancel btn-secondary"
					@click="changePasswordDialog = false" />
				<Button label="Save" class="p-button-rounded btn-save btn-primary" @click="savePassword" />
			</template>
		</Dialog>
	</div>
</template>

<script lang="ts" setup>
import { ref, onBeforeMount, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from 'vue-router';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import { required, minLength, sameAs, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import { useStore } from 'vuex';

const entstoreloading = ref(true);
const filters = ref({ 'global' : { value: null, matchMode: FilterMatchMode.CONTAINS } });
const loadingDT = ref(false);
const storeid = ref('');
const role = ref('');
const storestatus = ref('');
const router = useRouter();
const toast = useToast();
const users = ref();
const user = ref({ enterpriseid: '', storeid: '', storename: '', enterprisename: '', name: '', email: '', role: '', blocked: '', blockedbool: false, user_id: '' });
const enterprises = ref();
const enterprisestores = ref();
const createUserDialog = ref(false);
const viewUserDialog = ref(false);
const editUserDialog = ref(false);
const changePasswordDialog = ref(false);
const password = ref('');
const changePasswordFlag = ref(false);
const confirmpassword = ref('');
const rules = computed(() => ({
	password: { required: helpers.withMessage('Password cannot be empty', required), minLength: helpers.withMessage('Password must be at least 8 characters', minLength(8)), valid: helpers.withMessage('Password must contain uppercase, lowercase, number, special character', valid) },
	confirmpassword: { required: helpers.withMessage('Confirm password cannot be empty', required), sameAs: helpers.withMessage('Confirm password must be the same as New Password', sameAs(password)) },
}));

const rulesv = computed(() => ({
	enterpriseid: { required: helpers.withMessage('Enterprise cannot be empty.', required) },
	storeid: { required: helpers.withMessage('Enterprise store cannot be empty.', required) },
    name: { required: helpers.withMessage('Name cannot be empty.', required) },
    email: { required: helpers.withMessage('Email already exists in the system. Please use another.', required) },
}));

let vv$ = useVuelidate(rulesv, user);
let v$ = useVuelidate(rules, { password, confirmpassword });
const searchtext = ref('');
const confirm = useConfirm();
const auth0 = useAuth0();
const editInitialValue = ref();
let initialValues = {
  email: '',
  password: ''
};
const searchinitialValue = ref('');

onBeforeMount(async () => {
	loadingDT.value = true;
	const store = useStore();
	const auth0 = useAuth0();
	const accessToken = await auth0.getAccessTokenSilently();
	storeid.value = store.state.storeid;
	role.value = store.state.role;
	storestatus.value = store.state.storestatus;

	if (storestatus.value == 'Disable' || role.value != 'SupportAdmin') {
		router.push('/storedisable');
	}

	if (role.value === 'SupportAdmin') {
		await getAllEnterprises(accessToken);
		await getAllEnterpriseUsers(accessToken);
		loadingDT.value = false;
	}
});

const handleInputChange = (field) => {
	if (field === 'email') {
		initialValues.email = user.value.email;
	} else if (field === 'password') {
		initialValues.password = password.value;
	}
}

const handleFocus = (field) => {
	setTimeout(() => {
		if (field === 'email' && user.value.email === initialValues.email) {
			if (createUserDialog.value === true || changePasswordDialog.value === true) {
				user.value.email = '';
			}
		} else if (field === 'password' && password.value === initialValues.password) {
			if (createUserDialog.value === true || changePasswordDialog.value === true) {
				password.value = '';
			}
		}
	}, 0);
};

const getEnterpriseStores = async () => {
	try {
		entstoreloading.value = true;
		const accessToken = await auth0.getAccessTokenSilently();
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/stores/" + user.value.enterpriseid, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		enterprisestores.value = data.message;
		entstoreloading.value = false;
	} catch (e) {
		openErrorModal(e.message);
	}
}

const getAllEnterprises = async (accessToken: string) => {
	try {
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises", {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		enterprises.value = data.message;
		sortByEnterpriseName();
	} catch (e) {
		openErrorModal(e.message);
	}
}

const sortByEnterpriseName = () => {
	enterprises.value.sort((a, b) => {
		if (!a.EnterpriseName || !b.EnterpriseName) {
			throw new Error("Missing 'EnterpriseName' field for one or more objects in the array.");
		}
		
		return a.EnterpriseName.localeCompare(b.EnterpriseName);
	});
}

const getAllEnterpriseUsers = async (accessToken) => {
	try {
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users", {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}

		users.value = data.message;
		users.value.map((userItem) => {
			const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === userItem.enterpriseid);
			userItem.enterprisename = EnterpriseName;
		});
	} catch (e) {
		openErrorModal(e.message);
	}
}

const openCreateDialog = () => {
    createUserDialog.value = true;
	user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
    password.value = '';
    confirmpassword.value = '';
	vv$ = useVuelidate(rulesv, user);
    v$ = useVuelidate(rules, { password, confirmpassword });
}

/**
 * Initialize filter
 */
function clearFilter() {
	filters.value = {
		'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
	};
}

const viewUser = async (userDetail) => {
	viewUserDialog.value = true;
	user.value = userDetail;
	await getEnterpriseStores();
	const index = enterprisestores.value.findIndex(item => item.StoreId === user.value.storeid);
	if (index >= 0) {
		user.value.storeid = enterprisestores.value[index].StoreId;
		user.value.storename = enterprisestores.value[index].StoreName;
	}
}

const editUser = async (userDetail) => {
	user.value = userDetail;
	user.value.blockedbool = user.value.blocked === 'true';
    editUserDialog.value = true;
	editInitialValue.value = JSON.parse(JSON.stringify(userDetail));
	await getEnterpriseStores();
}

const saveUser = async () => {
    if (!await vv$.value.$validate()) return;
    if (!await v$.value.$validate()) return;
    try {
        let userdata = {
            name: user.value.name,
            email: user.value.email,
            blocked: user.value.blockedbool ? "true" : "false",
            password: password.value,
			enterpriseid: user.value.enterpriseid,
			storeid: user.value.storeid
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users", {
            method: 'POST',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
			if (data.error.message === 'Request failed with status code 409') {
				return toast.add({ severity: 'error', summary: 'Error', detail: 'The user already exists.', life: 3000 });
			}
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blockedbool ? "true" : "false";
        user.value.role = 'EnterpriseAdmin';
		const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === user.value.enterpriseid);
		user.value.enterprisename = EnterpriseName;
        users.value.push(user.value);
        user.value.user_id = data.message.result;
        
        createUserDialog.value = false;
        password.value = '';
        confirmpassword.value = '';
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
		entstoreloading.value = true;
		enterprisestores.value = [];

		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User has been created successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Create enterprise user failed.', life: 3000 });
    }
}

const updateUser = async () => {
	if (!await vv$.value.$validate()) return;
	try {
        let userdata = {
            name: user.value.name,
            email: user.value.email,
            blocked: user.value.blockedbool ? "true" : "false",
			enterpriseid: user.value.enterpriseid,
			storeid: user.value.storeid
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
		const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === user.value.enterpriseid);
		user.value.enterprisename = EnterpriseName;
        user.value.blocked = user.value.blockedbool ? "true" : "false";
        editUserDialog.value = false;
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };

		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User details have been updated successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Update enterprise user failed.', life: 3000 });
    }
}

const deleteUser = async () => {
    confirm.require({
		message: 'Do you want to delete the current user?',
		header: 'Please confirm deletion',
		icon: 'pi pi-exclamation-triangle',
		acceptClass: 'p-button-danger',
		accept: async () => {
			const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id;
			try {
				const accessToken = await auth0.getAccessTokenSilently();
				const response = await fetch(url, {
					method: 'DELETE',
					headers: {
						Authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json'
					},
				});
				//then delete user from array objects
				if (response.status >= 200 && response.status < 300) {
					for (var i = 0; i < users.value.length; i++) {
						if (users.value[i].user_id === user.value.user_id) {
							users.value.splice(i, 1);
							i--;
						}
					}
					toast.add({ severity: 'error', summary: 'Confirmed', detail: 'User has been deleted successfully.', life: 3000 });
				}				
				const data = await response.json();
				if (response.status > 400) {
					throw new Error(JSON.stringify(data.error));
				}
			} catch (e) {
				openErrorModal(e.message);
			}
		},
		reject: () => {
			toast.add({ severity: 'error', summary: 'Rejected', detail: 'User deletion cancelled.', life: 3000 });
		}
	});
	editUserDialog.value = false;
}

const savePassword = async () => {
	if (!await v$.value.$validate()) return;
	try {
        let userdata = {
            password: password.value
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
				'Update': 'Change-Password'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blockedbool ? "true" : "false";
		password.value = '';
		confirmpassword.value = '';
        changePasswordDialog.value = false;
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };

        toast.add({ severity: 'success', summary: 'Successful', detail: 'Password has been updated successfully.', life: 3000 });
		changePasswordFlag.value = true;
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Password update failed.', life: 3000 });
    }
}

const hideEditDialog = () => {
	const userIndex = users.value.findIndex(item => item.email == editInitialValue.value.email);
	users.value[userIndex] = editInitialValue.value;
    createUserDialog.value = false;
	viewUserDialog.value = false;
	editUserDialog.value = false;
	changePasswordDialog.value = false;
}

const changeUserPassword = (userDetail) => {
	user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
	password.value = '';
	confirmpassword.value = '';
    changePasswordDialog.value = true;
	user.value = userDetail;
	v$.value.$reset();
}

const blockunblockUser = async (userDetail) => {
	try {
		user.value = userDetail;
        let userdata = {
            blocked: user.value.blocked
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
				'Update': 'blockunblock'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blocked == 'true' ? "false" : "true";
		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User status has been updated successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'User status update failed.', life: 3000 });
    }
}

function valid(value: string) {
	const containsUppercase = /[A-Z]/.test(value);
	const containsLowercase = /[a-z]/.test(value);
	const containsNumber = /[0-9]/.test(value);
	const containsSpecial = /[#?!@$%^&*-]/.test(value);
	return containsUppercase && containsLowercase && containsNumber && containsSpecial;
}

const handleInputSearch = (event) => {
	if (changePasswordFlag.value == true) {
		setTimeout(() => { clearFilter(); changePasswordFlag.value = false;}, 0);
		return ;
	}
	searchinitialValue.value = event.target.value;
	searchtext.value = event.target.value;
	if (changePasswordDialog.value == true) {
		clearFilter();
		event.target.value = '';
		searchtext.value = '';
	} else {
		if (searchtext.value == '') {
			clearFilter();
			event.target.value = '';
			searchtext.value = '';
		}
		else {
			clearFilter();
			event.target.value = '';
			filters.value.global.value = searchtext.value;
		}
	}
}

const handleFocusSearch = () => {
    if (changePasswordFlag.value === true) {
        setTimeout(() => {
            clearFilter();
            changePasswordFlag.value = false;
        }, 0);
        return;
    }
    setTimeout(() => {
        if (searchtext.value === searchinitialValue.value) {
            searchtext.value = '';
        }
    }, 0);
};

const cancelSaveUser = () => {
	createUserDialog.value = false;
	entstoreloading.value = true;
	enterprisestores.value = [];
}
</script>